module.exports = __webpack_public_path__ + "static/media/arrow-sidebar-icon.a257a7ca.svg";